module.exports = __webpack_public_path__ + "img/debtPayingAbility9.8412f2f3.png";